module.exports = __webpack_public_path__ + "static/media/CAKE-BUSD.835044a8.svg";